import styled from 'styled-components'

const ContentWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin: 40px 16px;
    margin: 24px 16px 16px;

    & & {
        margin: 0;
    }

    @media (min-width: 641px) {
        & {
            margin: 30px 24px;
        }

        & & {
            margin: 30px 24px;
        }
    }

    @media (min-width: 1201px) {
        & {
            margin: 30px 43px;
        }

        & & {
            margin: 30px 43px;
        }
    }
`

ContentWrapper.displayName = 'ContentWrapper'

export default ContentWrapper